<template>
    <Paper>
        <div class="content p-2">
            <h5 class="m-4">
                {{ title }}
            </h5>

            <h6 class="m-4">
                {{ description }}
            </h6>

            <div class="details-container">
                <div class="details-item">
                    <font-awesome-icon class="gray-color details-icon" icon="clock" />
                    <div>
                        {{ duration }}
                        {{ $t('general.minutesShort') }}
                    </div>
                </div>

                <div class="details-item">
                    <font-awesome-icon class="gray-color details-icon" icon="map-marker-alt" />
                    <div>{{ location }}</div>
                </div>
            </div>
        </div>
    </Paper>
</template>

<script>
import AnalyticService from '~/services/AnalyticService';
import Button from '~/components/builders/Base/Button';
import Icon from '~/components/builders/Base/Icon';
import Paper from '~/components/builders/Paper';

import dateToString from '~/utils/dateToString';
import moment from 'moment';
import tz from 'moment-timezone';

export default {
    name: 'AppointmentDetailsCard',
    components: { Paper },
    props: {
        duration: { type: Number, required: true },
        title: { type: String, required: true },
        location: { type: String, required: true },
        description: { type: String, required: true },
    },
    computed: {
        startDate() {
            return dateToString(this.data.start_time, true, true);
        },
        startTime() {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return moment(this.data.start_time)
                .tz(timeZone)
                .format('LT a');
        },
        endTime() {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return moment(this.data.end_time)
                .tz(timeZone)
                .format('LT a z');
        },
    },
    data: () => ({
        hasLoggedAppointmentClickEvent: false,
    }),
    methods: {
        async logAppointmentTypeClickEvent() {
            if (this.hasLoggedAppointmentClickEvent || !this.data.id) return;
            AnalyticService.appointmentTypeClickEvent(this.data.id);
            this.hasLoggedAppointmentClickEvent = true;
        },
    },
};
</script>

<style scoped>
.details-container {
    display: flex;
    flex-direction: column;
    margin: 1rem;
}

.details-item {
    padding-right: 1rem;
    padding-bottom: 0.5rem;
    display: grid;
    grid-template-columns: 0.1fr 1fr;
    align-items: center;

    word-break: break-all;
}

.details-icon {
    justify-self: center;
}

.actions-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.action-item {
    padding-right: 1em;
    align-items: center;
}
</style>
